"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Palette is based on a color from the secondary colors in
 * mnemonic design manual
 * All palettes are created using
 * https://material.io/design/color/the-color-system.html#tools-for-picking-colors
 */
const tertiary1 = {
    50: "#E1F2F2",
    100: "#B5E0DF",
    200: "#86CDCA",
    300: "#57B9B4",
    400: "#38A9A3",
    500: "#219A92",
    600: "#1E8D84",
    700: "#1B7D74",
    800: "#186D64",
    900: "#125147",
    A100: "#E1F2F2",
    A200: "#86CDCA",
    A400: "#57B9B4",
    A700: "#219A92",
};
exports.default = tertiary1;
